import { SecShape, type SecondaryDef } from '../../sim/secondary';

/** S03 — FAISCEAU BREF. La seule arme du catalogue qui demande de TENIR une
 *  position, et c'est toute sa raison d'être.
 *
 *  ── Le besoin ────────────────────────────────────────────────────────────
 *  Un ennemi lourd (Faucheur, porteur blindé par ses parties) exige plusieurs
 *  secondes de tir soutenu. La primaire les fournit, mais seulement si le
 *  joueur reste aligné — ce qu'il ne peut pas toujours. Le Faisceau condense
 *  cette fenêtre : 810 dégâts en 0,54 s, soit 1 500 DPS instantanés, sept fois
 *  la primaire. Il ne fait pas gagner un combat, il fait gagner du TEMPS dans un
 *  combat, ce qui est autre chose.
 *
 *  ── Pourquoi une rafale et non un projectile unique ──────────────────────
 *  Un projectile unique à 810 dégâts serait la même chose en chiffres et une
 *  arme entièrement différente à jouer : on cliquerait, ce serait fini. Les
 *  dix-huit volées créent une DURÉE pendant laquelle le vaisseau doit rester sur
 *  sa ligne, et chaque volée part de la position courante — le faisceau balaie
 *  donc avec le vaisseau. Le joueur qui bouge pendant sa fenêtre perd la moitié
 *  de ses dégâts ; celui qui tient sa ligne les encaisse tous. C'est la seule
 *  arme du jeu où l'esquive et le dégât sont directement en tension, et cette
 *  tension est le contenu.
 *
 *  Conséquence technique heureuse : la simulation ne connaît toujours que des
 *  projectiles. Aucune primitive « rayon » à faire entrer dans la collision
 *  balayée, aucun cas particulier — c'est la donnée qui fabrique la sensation.
 *
 *  ── Pourquoi 7 s de recharge ─────────────────────────────────────────────
 *  La plus longue du catalogue, parce que c'est le plus gros burst. À 4 s, elle
 *  couvrirait toutes les fenêtres et les trois autres armes n'auraient plus de
 *  raison d'exister. */
const faisceau: SecondaryDef = {
  id: 'faisceau-bref',
  name: 'Faisceau bref',
  shape: SecShape.Faisceau,
  cooldown: 7,
  // 18 volées × 30 ms = 0,54 s. « Bref » est une donnée, pas une intention :
  // au-delà de ~0,8 s le joueur ne peut plus tenir sa ligne dans un rideau et
  // l'arme se transforme en punition.
  shots: 18,
  shotEvery: 0.03,
  count: 1,
  spacing: 0,
  spreadDeg: 0,
  // Le plus rapide du jeu. À 2 600 u/s et 30 ms de période, deux segments
  // consécutifs sont distants de 78 u pour 52 u de diamètre : ils se lisent
  // comme un trait continu sans jamais se superposer, donc sans gaspiller de
  // dégâts sur la même cible au même instant.
  // 2 200 et non 2 600 : plafond des tirs joueur (PLAN.md §6.4). L'écart ne se
  // ressent pas — 0,05 s de plus sur la traversée — mais le repère qui distingue
  // « ce qui vient de moi » de « ce qui me tue » ne survit que s'il est tenu.
  speed: 2200,
  radius: 26,
  damage: 45,
  text: '18 × 45 dégâts en 0,5 s, faisceau continu — 7 s',
};

export default faisceau;
